module.exports = __webpack_public_path__ + "static/media/pic3.28c0011a.png";